/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
export default (theme) => ({
    DesktopTrackOrderByEmailStyle: {
        '& .heading': {
            fontFamily: 'BebasNeue',
            fontSize: '2.8rem !important',
            fontWeight: '500 !important',

            [theme.breakpoints.down('md')]: {
                lineHeight: '45px',
            },
        },

        '& .situationMsg, & .requiredValidation': {
            fontSize: '16px !important',
            fontWeight: '500',
            lineHeight: '1.2',
        },

        '& .requiredValidation': {
            marginBottom: '1.5rem',
        },

        '& .iconPosition': {
            position: 'relative',
        },

        '& .form-container': {
            width: '40%',

            '& button': {
                margin: '0 !important',
                width: '100% !important',
                float: 'left !important',
                color: '#212324 !important',
                border: '1px solid #b9e529 !important',
                backgroundColor: '#b9e529 !important',
            },

            '& .alert': {
                marginBottom: '20px',
            },

            [theme.breakpoints.down('sm')]: {
                width: '100%',
            },
        },

        '& .mt-4, &.my-4': {
            marginTop: '1.5rem !important',
        },

        '& .mb-4': {
            marginBottom: '1.5rem !important',
        },

        '& .mt-2, .my-2': {
            marginTop: '0.5rem !important',
        },

        '& .pt-md-1, & .py-md-1': {
            paddingTop: '0.25rem !important',
        },

        '& .mb-1, & .my-1': {
            marginBottom: '0.25rem !important',
        },

        '& .pb-4, & .py-4': {
            paddingBottom: '1.5rem !important',
        },

        '& .pl-0, & .px-0': {
            paddingLeft: '0 !important',
        },

        '& .font-weight-bold': {
            fontWeight: '700 !important',
        },

        '& .mb-5, &.my-5': {
            marginBottom: '3rem !important',
        },

        '& .mb-3, &.my-3': {
            marginBottom: '1rem !important',
        },

        '& .mb-md-4, & .my-md-4': {
            marginBottom: '2.5rem !important',
        },
    },

    inputWrapper: {
        position: 'relative',
        paddingBottom: '30px',
        '& label': {
            display: 'none',
            '&+ div': {
                margin: 0,
                padding: '8px 0',
                fontSize: '1.14rem !important',
                '& input': {
                    fontSize: '1.14rem !important',
                },
            },
        },
        '& > div p': {
            position: 'absolute',
            width: '100%',
            left: 0,
            bottom: '-26px',
        },
    },
    inputLabel: {
        '& > label': {
            display: 'block',
            color: '#000000',
            fontSize: '1rem !important',
            '& + div': {
                padding: '0',
            },
        },
    },
    inputTitle: {
        margin: 0,
        paddingBottom: '5px',
        fontWeight: 600,
    },
});
